var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgChevronDown = function SvgChevronDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.412 7.5a.831.831 0 0 0-1.175-.001L10 10.729l-3.237-3.23a.831.831 0 0 0-1.175 1.176l3.705 3.705a1 1 0 0 0 1.414 0l3.705-3.705a.831.831 0 0 0 0-1.176Z"
  })));
};
export default SvgChevronDown;